module.exports = __webpack_public_path__ + "img/c05_buildingtechmarianreformation_Normal_ua.dcbb0c9b.webp";